
import Vue from 'vue';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(
    'div',
    { staticClass: 'su-alert' },
    [
      _c(
        'b-alert',
        {
          attrs: { show: _vm.dismissCountDown, dismissible: '', variant: 'dark', fade: '' },
          on: {
            dismissed: function ($event) {
              _vm.dismissCountDown = 0;
            },
            'dismiss-count-down': _vm.countDownChanged,
          },
        },
        [
          _c('p', [_vm._v(_vm._s(_vm.message))]),
          _c('b-progress', {
            attrs: {
              variant: 'dark',
              max: _vm.dismissSecs,
              value: _vm.dismissCountDown,
              height: '4px',
            },
          }),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [];

export default Vue.extend({
  render,
  staticRenderFns,
  name: 'Alert',
  props: {},
  data() {
    return {
      dismissSecs: 4,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      message: '',
    };
  },
  methods: {
    countDownChanged: function (dismissCD) {
      this.$data.dismissCountDown = dismissCD;
    },
    showAlert: function (message) {
      this.$data.message = message;
      this.$data.dismissCountDown = this.$data.dismissSecs;
    },
  },
});
